import Card, { CardProps } from "@mui/material/Card";

export type { CardProps };

export default Card;
